/* eslint-disable */
import * as React from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { red } from "@mui/material/colors";
import { useState } from "react";
import { useEffect } from "react";
import { SharePointFolder } from "../../services/apigateway";
import { useParams } from "react-router";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";

export default function RequiredUploadDocuments({
  uploadType,
  isEdited,
  objChangeMasterFile,
  setObjChangeMasterFile,
  setShowTableOther,
  setShowTableOtherAudited,
  setSelectedOther,
  setSelectedAudited,
  setSelectedCOI,
  setSelectedMOA,
  setSelectedRegVat,
  setSelectedListShareHold,
  setSelectedMOE,
  selectedOther,
  selectedAudited,
  selectedCOI,
  selectedMOA,
  selectedRegVat,
  selectedListShareHold,
  selectedMOE,
  setLoading
}) {
  const errorFileLimitText = "All files size uploaded not over 20MB.";

  const [required, setRequired] = useState({
    fields: "",
    active: false,
  });

  const { id } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await ChangeMasterFileAPI.getChangeMasterFilelist(id);
        // setObjChangeMasterFile(response);
        // const userInfo = helper.Auth.getTokenData()
        if (id) {
          getSharePointFiles(id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const isOverLimilFileSize = (fileSize) => {
    const megabytes = 20;
    const sizeMaximun = megabytes * 1048576;
    const files = objChangeMasterFile.Documents;
    let sizes = [];
    const getSizes = (obj) => {
      for (const key in obj) {
        if (obj[key] !== null && typeof obj[key] === "object") {
          getSizes(obj[key]);
        } else if (key === "Size") {
          sizes.push(obj[key]);
        }
      }
    };

    getSizes(files);
    getSizes(selectedOther);
    let totalSize = 0;
    totalSize = sizes.reduce((sum, size) => sum + size, 0);
    const sumInputFileSize = fileSize + totalSize;
    if (sumInputFileSize >= sizeMaximun) {
      return true;
    } else {
      return false;
    }
  };

  const getFileNameAndSize = (file) => {
    const FileDetails = Array.from(file).map((file) => ({
      name: file.name,
      size: file.size,
    }));

    const FileName = FileDetails[0].name;
    const FileSize = FileDetails[0].size;

    return { FileName, FileSize };
  };

  // function upload other file
  function addFileToUploadList() {
    const attachments2 = document.getElementById("FileOther2").files;
    var fileBuffer = new DataTransfer();
    for (let i = 0; i < attachments2.length; i++) {
      fileBuffer.items.add(attachments2[i]);
    }

    const attachments1 = document.getElementById("FileOther1").files;
    for (let i = 0; i < attachments1.length; i++) {
      fileBuffer.items.add(attachments1[i]);
    }

    let fileNamesChecks = Array.from(attachments1).map((file) => file);
    if (isValidCheckFiles(fileNamesChecks, "FileOther")) {
      document.getElementById("FileOther2").files = fileBuffer.files;
      document.getElementById("FileOther1").files = new DataTransfer().files;

      let newSelectedOther = [];
      for (let i = 0; i < fileBuffer.files.length; i++) {
        newSelectedOther.push({
          Filename: fileBuffer.files[i].name,
          Size: fileBuffer.files[i].size,
        });
      }
      // Update the state to reflect the new files
      setSelectedOther(newSelectedOther); // Assuming setSelectedOther is the state update function
      setShowTableOther(true);
    }
  }
  function removeFileFromUploadList(indexToRemove) {
    var attachments = document.getElementById("FileOther2").files;
    var fileBuffer = new DataTransfer();

    for (let i = 0; i < attachments.length; i++) {
      if (indexToRemove !== i) fileBuffer.items.add(attachments[i]);
    }

    document.getElementById("FileOther2").files = fileBuffer.files;
    const updatedFiles = selectedOther.filter(
      (_, index) => index !== indexToRemove
    );
    setSelectedOther(updatedFiles);
  }
  function handleChangeFileOther(e) {
    const fileDetail = getFileNameAndSize(e.target.files);
    const isOverLimit = isOverLimilFileSize(fileDetail.FileSize);
    if (isOverLimit) {
      Swal.fire({
        title: errorFileLimitText,
        icon: "error",
        showConfirmButton: true,
      });
    } else {
      addFileToUploadList();
    }
  }

  // COI
  function addFileToUploadCOI() {
    const attachments2 = document.getElementById("FileCOI2").files;
    var fileBuffer = new DataTransfer();
    for (let i = 0; i < attachments2.length; i++) {
      fileBuffer.items.add(attachments2[i]);
    }

    const attachments1 = document.getElementById("FileCOI1").files;
    for (let i = 0; i < attachments1.length; i++) {
      fileBuffer.items.add(attachments1[i]);
    }

    let fileNamesChecks = Array.from(attachments1).map((file) => file);
    if (isValidCheckFiles(fileNamesChecks, "FileOther")) {
      document.getElementById("FileCOI2").files = fileBuffer.files;
      document.getElementById("FileCOI1").files = new DataTransfer().files;

      let newSelectedOther = [];
      for (let i = 0; i < fileBuffer.files.length; i++) {
        newSelectedOther.push({
          Filename: fileBuffer.files[i].name,
          Size: fileBuffer.files[i].size,
        });
      }
      // Update the state to reflect the new files
      setSelectedCOI(newSelectedOther); // Assuming setSelectedOther is the state update function
    }
  }
  function removeFileFromUploadCOI(indexToRemove) {
    var attachments = document.getElementById("FileCOI2").files;
    var fileBuffer = new DataTransfer();

    for (let i = 0; i < attachments.length; i++) {
      if (indexToRemove !== i) fileBuffer.items.add(attachments[i]);
    }

    document.getElementById("FileCOI2").files = fileBuffer.files;
    const updatedFiles = selectedCOI.filter(
      (_, index) => index !== indexToRemove
    );
    setSelectedCOI(updatedFiles);
  }
  function handleChangeFileCOI(e) {
    const fileDetail = getFileNameAndSize(e.target.files);
    const isOverLimit = isOverLimilFileSize(fileDetail.FileSize);
    if (isOverLimit) {
      Swal.fire({
        title: errorFileLimitText,
        icon: "error",
        showConfirmButton: true,
      });
    } else {
      addFileToUploadCOI();
    }
  }

  // MOA
  function addFileToUploadMOA() {
    const attachments2 = document.getElementById("FileMOA2").files;
    var fileBuffer = new DataTransfer();
    for (let i = 0; i < attachments2.length; i++) {
      fileBuffer.items.add(attachments2[i]);
    }

    const attachments1 = document.getElementById("FileMOA1").files;
    for (let i = 0; i < attachments1.length; i++) {
      fileBuffer.items.add(attachments1[i]);
    }

    let fileNamesChecks = Array.from(attachments1).map((file) => file);
    if (isValidCheckFiles(fileNamesChecks, "FileMOA")) {
      document.getElementById("FileMOA2").files = fileBuffer.files;
      document.getElementById("FileMOA1").files = new DataTransfer().files;

      let newSelectedOther = [];
      for (let i = 0; i < fileBuffer.files.length; i++) {
        newSelectedOther.push({
          Filename: fileBuffer.files[i].name,
          Size: fileBuffer.files[i].size,
        });
      }
      // Update the state to reflect the new files
      setSelectedMOA(newSelectedOther); // Assuming setSelectedOther is the state update function
    }
  }
  function removeFileFromUploadMOA(indexToRemove) {
    var attachments = document.getElementById("FileMOA2").files;
    var fileBuffer = new DataTransfer();

    for (let i = 0; i < attachments.length; i++) {
      if (indexToRemove !== i) fileBuffer.items.add(attachments[i]);
    }

    document.getElementById("FileMOA2").files = fileBuffer.files;
    const updatedFiles = selectedMOA.filter(
      (_, index) => index !== indexToRemove
    );
    setSelectedMOA(updatedFiles);
  }
  function handleChangeFileMOA(e) {
    const fileDetail = getFileNameAndSize(e.target.files);
    const isOverLimit = isOverLimilFileSize(fileDetail.FileSize);
    if (isOverLimit) {
      Swal.fire({
        title: errorFileLimitText,
        icon: "error",
        showConfirmButton: true,
      });
    } else {
      addFileToUploadMOA();
    }
  }

  // RegVat
  function addFileToUploadRegVat() {
    const attachments2 = document.getElementById("FileRegVat2").files;
    var fileBuffer = new DataTransfer();
    for (let i = 0; i < attachments2.length; i++) {
      fileBuffer.items.add(attachments2[i]);
    }

    const attachments1 = document.getElementById("FileRegVat1").files;
    for (let i = 0; i < attachments1.length; i++) {
      fileBuffer.items.add(attachments1[i]);
    }

    let fileNamesChecks = Array.from(attachments1).map((file) => file);
    if (isValidCheckFiles(fileNamesChecks, "FileRegVat")) {
      document.getElementById("FileRegVat2").files = fileBuffer.files;
      document.getElementById("FileRegVat1").files = new DataTransfer().files;

      let newSelectedOther = [];
      for (let i = 0; i < fileBuffer.files.length; i++) {
        newSelectedOther.push({
          Filename: fileBuffer.files[i].name,
          Size: fileBuffer.files[i].size,
        });
      }
      // Update the state to reflect the new files
      setSelectedRegVat(newSelectedOther); // Assuming setSelectedOther is the state update function
    }
  }
  function removeFileFromUploadRegVat(indexToRemove) {
    var attachments = document.getElementById("FileRegVat2").files;
    var fileBuffer = new DataTransfer();

    for (let i = 0; i < attachments.length; i++) {
      if (indexToRemove !== i) fileBuffer.items.add(attachments[i]);
    }

    document.getElementById("FileRegVat2").files = fileBuffer.files;
    const updatedFiles = selectedRegVat.filter(
      (_, index) => index !== indexToRemove
    );
    setSelectedRegVat(updatedFiles);
  }
  function handleChangeFileRegVat(e) {
    const fileDetail = getFileNameAndSize(e.target.files);
    const isOverLimit = isOverLimilFileSize(fileDetail.FileSize);
    if (isOverLimit) {
      Swal.fire({
        title: errorFileLimitText,
        icon: "error",
        showConfirmButton: true,
      });
    } else {
      addFileToUploadRegVat();
    }
  }

  // List Share Holder
  function addFileToUploadListShareHold() {
    const attachments2 = document.getElementById("FileListShareHold2").files;
    var fileBuffer = new DataTransfer();
    for (let i = 0; i < attachments2.length; i++) {
      fileBuffer.items.add(attachments2[i]);
    }

    const attachments1 = document.getElementById("FileListShareHold1").files;
    for (let i = 0; i < attachments1.length; i++) {
      fileBuffer.items.add(attachments1[i]);
    }

    let fileNamesChecks = Array.from(attachments1).map((file) => file);
    if (isValidCheckFiles(fileNamesChecks, "FileListShareHold")) {
      document.getElementById("FileListShareHold2").files = fileBuffer.files;
      document.getElementById("FileListShareHold1").files =
        new DataTransfer().files;

      let newSelectedOther = [];
      for (let i = 0; i < fileBuffer.files.length; i++) {
        newSelectedOther.push({
          Filename: fileBuffer.files[i].name,
          Size: fileBuffer.files[i].size,
        });
      }
      // Update the state to reflect the new files
      setSelectedListShareHold(newSelectedOther); // Assuming setSelectedOther is the state update function
    }
  }
  function removeFileFromUploadListShareHold(indexToRemove) {
    var attachments = document.getElementById("FileListShareHold2").files;
    var fileBuffer = new DataTransfer();

    for (let i = 0; i < attachments.length; i++) {
      if (indexToRemove !== i) fileBuffer.items.add(attachments[i]);
    }

    document.getElementById("FileListShareHold2").files = fileBuffer.files;
    const updatedFiles = selectedListShareHold.filter(
      (_, index) => index !== indexToRemove
    );
    setSelectedListShareHold(updatedFiles);
  }
  function handleChangeFileListShareHold(e) {
    const fileDetail = getFileNameAndSize(e.target.files);
    const isOverLimit = isOverLimilFileSize(fileDetail.FileSize);
    if (isOverLimit) {
      Swal.fire({
        title: errorFileLimitText,
        icon: "error",
        showConfirmButton: true,
      });
    } else {
      addFileToUploadListShareHold();
    }
  }

  // List Share Holder
  function addFileToUploadMOE() {
    const attachments2 = document.getElementById("FileListMOE2").files;
    var fileBuffer = new DataTransfer();
    for (let i = 0; i < attachments2.length; i++) {
      fileBuffer.items.add(attachments2[i]);
    }

    const attachments1 = document.getElementById("FileListMOE1").files;
    for (let i = 0; i < attachments1.length; i++) {
      fileBuffer.items.add(attachments1[i]);
    }

    let fileNamesChecks = Array.from(attachments1).map((file) => file);
    if (isValidCheckFiles(fileNamesChecks, "FileListMOE")) {
      document.getElementById("FileListMOE2").files = fileBuffer.files;
      document.getElementById("FileListMOE1").files = new DataTransfer().files;

      let newSelectedOther = [];
      for (let i = 0; i < fileBuffer.files.length; i++) {
        newSelectedOther.push({
          Filename: fileBuffer.files[i].name,
          Size: fileBuffer.files[i].size,
        });
      }
      // Update the state to reflect the new files
      setSelectedMOE(newSelectedOther); // Assuming setSelectedOther is the state update function
    }
  }
  function removeFileFromUploadMOE(indexToRemove) {
    var attachments = document.getElementById("FileListMOE2").files;
    var fileBuffer = new DataTransfer();

    for (let i = 0; i < attachments.length; i++) {
      if (indexToRemove !== i) fileBuffer.items.add(attachments[i]);
    }

    document.getElementById("FileListMOE2").files = fileBuffer.files;
    const updatedFiles = selectedMOE.filter(
      (_, index) => index !== indexToRemove
    );
    setSelectedMOE(updatedFiles);
  }
  function handleChangeFileMOE(e) {
    const fileDetail = getFileNameAndSize(e.target.files);
    const isOverLimit = isOverLimilFileSize(fileDetail.FileSize);
    if (isOverLimit) {
      Swal.fire({
        title: errorFileLimitText,
        icon: "error",
        showConfirmButton: true,
      });
    } else {
      addFileToUploadMOE();
    }
  }

  // function upload audited file
  function addFileToUploadListAudited() {
    const attachments2 = document.getElementById("FileOther2Audited").files;
    var fileBuffer = new DataTransfer();
    for (let i = 0; i < attachments2.length; i++) {
      fileBuffer.items.add(attachments2[i]);
    }

    const attachments1 = document.getElementById("FileOther1Audited").files;
    for (let i = 0; i < attachments1.length; i++) {
      fileBuffer.items.add(attachments1[i]);
    }

    let fileNamesChecks = Array.from(attachments1).map((file) => file);
    if (isValidCheckFiles(fileNamesChecks, "FileOtherAudited")) {
      document.getElementById("FileOther2Audited").files = fileBuffer.files;
      document.getElementById("FileOther1Audited").files =
        new DataTransfer().files;

      let newSelectedOther = [];
      for (let i = 0; i < fileBuffer.files.length; i++) {
        newSelectedOther.push({
          Filename: fileBuffer.files[i].name,
          Size: fileBuffer.files[i].size,
        });
      }

      setSelectedAudited(newSelectedOther);
      setShowTableOtherAudited(true);
    }
  }
  function removeFileFromUploadListAudited(indexToRemove) {
    const fileInput = document.getElementById("FileOther2Audited");
    if (!fileInput) return;

    const attachments = fileInput.files;
    const fileBuffer = new DataTransfer();

    for (let i = 0; i < attachments.length; i++) {
      if (i !== indexToRemove) {
        fileBuffer.items.add(attachments[i]);
      }
    }

    fileInput.files = fileBuffer.files;

    const updatedFiles = selectedAudited.filter(
      (_, index) => index !== indexToRemove
    );
    setSelectedAudited(updatedFiles);
  }
  function handleChangeFileAudited(e) {
    const fileDetail = getFileNameAndSize(e.target.files);
    const isOverLimit = isOverLimilFileSize(fileDetail.FileSize);
    if (isOverLimit) {
      Swal.fire({
        title: errorFileLimitText,
        icon: "error",
        showConfirmButton: true,
      });
    } else {
      addFileToUploadListAudited();
    }
  }

  const [filesSharePoint, setFilesSharePoint] = useState([
    {
      Account_Common_CTR_Financial: [],
      Account_Common_CTR_COI: [],
      Account_Common_CTR_MOA: [],
      Account_Common_CTR_List_Sharehold: [],
      Account_Common_CTR_VAT_Reg: [],
      Account_Common_CTR_Reg_by_MoE: [],
      Account_Common_CTR_Others: [],
    },
  ]);

  const getSharePointFiles = async (id) => {
    try {
      const results = await SharePointFolder.getFileByAccount(id);
      const filesSharePoint = results.responseData;

      const mappedFiles = {
        Account_Common_CTR_Financial: [],
        Account_Common_CTR_COI: [],
        Account_Common_CTR_MOA: [],
        Account_Common_CTR_List_Sharehold: [],
        Account_Common_CTR_VAT_Reg: [],
        Account_Common_CTR_Reg_by_MoE: [],
        Account_Common_CTR_Others: [],
      };

      filesSharePoint.forEach((folder) => {
        if (mappedFiles.hasOwnProperty(folder.Name)) {
          mappedFiles[folder.Name] = (folder.Files || []).sort(
            (a, b) => new Date(a.TimeCreated) - new Date(b.TimeCreated)
          );
        }
      });

      setFilesSharePoint(mappedFiles);
    } catch (errors) {
      console.error(errors);
    } finally {
      setLoading(false)
    }
  };

  function isValidCheckFiles(file, name) {
    let newFile = file[0];
    // check size
    const maxFileSizeMB = 5;
    const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;

    // check type
    const acceptedExtensions = [
      ".jpg",
      ".png",
      ".pdf",
      ".xls",
      ".xlsx",
      ".doc",
      ".docx",
    ];
    let fileExtension = newFile.name
      .toLowerCase()
      .substring(newFile.name.lastIndexOf("."));

    if (acceptedExtensions.includes(fileExtension)) {
      document.getElementById(name).innerText = "";
      if (newFile.size < maxFileSizeBytes) {
        document.getElementById(name).innerText = "";
        return true;
      } else {
        document.getElementById(name).innerText =
          "Allow upload file size 5MB per file.";
        return false;
      }
    } else {
      document.getElementById(name).innerText =
        "Allow upload file type: JPG, PNG, PDF, XLS, XLSX, DOC, DOCX";
      return false;
    }
  }

  return (
    <Card>
      <CardContent>
        {/* title required */}
        <Box sx={{ m: 2 }}>
          <strong>File upload conditions:</strong>
          <Box sx={{ ml: 2 }}>
            1. Allow upload file type: JPG, PNG, PDF, XLS, XLSX, DOC, DOCX.{" "}
            <br />
            2. Allow upload file size 5MB per file.
            <br />
            3. All files size uploaded not over 20MB.
          </Box>
        </Box>

        {/* Upload-All-List */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
          }}
        >
          {uploadType && uploadType === "Credit Annual Review" ? (
            <Box sx={{ p: 0, m: 0, width: "100%" }}>
              {/* Audited Financial Statements */}
              <Typography variant="subtitle1" gutterBottom>
                <Box sx={{ textIndent: 20 }}>
                  {/* table result  */}
                  <TableContainer component={Paper} sx={{ m: 2 }}>
                    <div
                      style={{ backgroundColor: "#E1E5ED", fontWeight: "bold" }}
                    >
                      Audited Financial Statements with Notes to the Financial
                      Statements (last 3 years)
                    </div>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="120px">
                            No.
                          </TableCell>
                          <TableCell align="left">File Name</TableCell>
                          <TableCell align="left">Upload Date/Time</TableCell>
                          <TableCell align="center" width="150px">
                            Delete
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filesSharePoint?.Account_Common_CTR_Financial?.map(
                          (item, index) => {
                            if (item) {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {item.Name}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {moment(item.TimeCreated).format(
                                        "DD-MMM-YYYY HH:mm a"
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    &nbsp;
                                    {/* <ClearIcon
                                    data-name={item.Name}
                                    sx={{ color: red[500], cursor: "pointer" }}
                                    onClick={(evt) => {
                                      const index =
                                        objChangeMasterFile.Documents.Others.findIndex(
                                          (item) => {
                                            return (
                                              item ===
                                              evt.currentTarget.dataset.name
                                            );
                                          }
                                        );
                                      objChangeMasterFile.Documents.Others.splice(
                                        index,
                                        1
                                      );
                                      setObjChangeMasterFile({
                                        ...objChangeMasterFile,
                                      });
                                    }}
                                  /> */}
                                  </TableCell>
                                </TableRow>
                              );
                            } else {
                              return null;
                            }
                          }
                        )}
                        {selectedAudited?.map((fileName, index) => {
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                -
                                {/* {objChangeMasterFile?.Documents?.Others
                                ? objChangeMasterFile?.Documents?.Others
                                    ?.length +
                                  index +
                                  1
                                : index + 1} */}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                {fileName.Filename}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <span
                                  className="link-download"
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  {moment(new Date()).format(
                                    "DD-MMM-YYYY HH:mm a"
                                  )}
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                <ClearIcon
                                  sx={{ color: red[500], cursor: "pointer" }}
                                  onClick={() =>
                                    removeFileFromUploadListAudited(index)
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* box-upload */}
                  <Box sx={{ display: "flex", flexDirecttion: "row", mt: 2 }}>
                    <Box className="upload-box" sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 1 }}>
                        {/* Input element for file selection */}
                        <input
                          type="file"
                          id="FileOther2Audited"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                        />

                        {/* Input element for file selection */}
                        <input
                          type="file"
                          onChange={handleChangeFileAudited}
                          id="FileOther1Audited"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                          // disabled={!isEdited}
                          multiple={false}
                        />
                        <label htmlFor="FileOther1Audited">
                          <Button
                            variant="outlined"
                            component="span"
                            disabled={!isEdited}
                            style={{ color: "#2C88D9" }}
                          >
                            Upload File
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 2 }}>
                        <label
                          id="FileOtherAudited"
                          style={{
                            color: "red",
                            fontSize: 14,
                            verticalAlign: "sub",
                          }}
                        ></label>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Typography>
            </Box>
          ) : (
            <Box sx={{ p: 0, m: 2, width: "100%" }}>
              {/* Audited Financial Statements */}
              <Typography variant="subtitle1" gutterBottom>
                <Box sx={{ textIndent: 20 }}>
                  {/* table result  */}
                  <TableContainer component={Paper}>
                    <div
                      style={{ backgroundColor: "#E1E5ED", fontWeight: "bold" }}
                    >
                      Audited Financial Statements with Notes to the Financial
                      Statements (last 3 years)
                    </div>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="120px">
                            No.
                          </TableCell>
                          <TableCell align="left">File Name</TableCell>
                          <TableCell align="left">Upload Date/Time</TableCell>
                          <TableCell align="center" width="150px">
                            Delete
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filesSharePoint?.Account_Common_CTR_Financial?.map(
                          (item, index) => {
                            if (item) {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {item.Name}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {moment(item.TimeCreated).format(
                                        "DD-MMM-YYYY HH:mm a"
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    &nbsp;
                                    {/* <ClearIcon
                                    data-name={item.Name}
                                    sx={{ color: red[500], cursor: "pointer" }}
                                    onClick={(evt) => {
                                      const index =
                                        objChangeMasterFile.Documents.Others.findIndex(
                                          (item) => {
                                            return (
                                              item ===
                                              evt.currentTarget.dataset.name
                                            );
                                          }
                                        );
                                      objChangeMasterFile.Documents.Others.splice(
                                        index,
                                        1
                                      );
                                      setObjChangeMasterFile({
                                        ...objChangeMasterFile,
                                      });
                                    }}
                                  /> */}
                                  </TableCell>
                                </TableRow>
                              );
                            } else {
                              return null;
                            }
                          }
                        )}
                        {selectedAudited?.map((fileName, index) => {
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                -
                                {/* {objChangeMasterFile?.Documents?.Others
                                ? objChangeMasterFile?.Documents?.Others
                                    ?.length +
                                  index +
                                  1
                                : index + 1} */}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                {fileName.Filename}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <span
                                  className="link-download"
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  {moment(new Date()).format(
                                    "DD-MMM-YYYY HH:mm a"
                                  )}
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                <ClearIcon
                                  sx={{ color: red[500], cursor: "pointer" }}
                                  onClick={() =>
                                    removeFileFromUploadListAudited(index)
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* box-upload */}
                  <Box sx={{ display: "flex", flexDirecttion: "row", mt: 2 }}>
                    <Box className="upload-box" sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 1 }}>
                        {/* Input element for file selection */}
                        <input
                          type="file"
                          id="FileOther2Audited"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                        />

                        {/* Input element for file selection */}
                        <input
                          type="file"
                          onChange={handleChangeFileAudited}
                          id="FileOther1Audited"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                          // disabled={!isEdited}
                          multiple={false}
                        />
                        <label htmlFor="FileOther1Audited">
                          <Button
                            variant="outlined"
                            component="span"
                            disabled={!isEdited}
                            style={{ color: "#2C88D9" }}
                          >
                            Upload File
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 2 }}>
                        <label
                          id="FileOtherAudited"
                          style={{
                            color: "red",
                            fontSize: 14,
                            verticalAlign: "sub",
                          }}
                        ></label>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Typography>

              {/* Certificate of Incorporation (COI) */}
              <Typography variant="subtitle1" gutterBottom>
                <Box sx={{ textIndent: 20 }}>
                  {/* table result */}
                  <TableContainer component={Paper} sx={{ m: 2 }}>
                    <div
                      style={{ backgroundColor: "#E1E5ED", fontWeight: "bold" }}
                    >
                      Certificate of Incorporation (COI)
                    </div>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="120px">
                            No.
                          </TableCell>
                          <TableCell align="left">File Name</TableCell>
                          <TableCell align="left">Upload Date/Time</TableCell>
                          <TableCell align="center" width="150px">
                            Delete
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filesSharePoint?.Account_Common_CTR_COI?.map(
                          (item, index) => {
                            if (item) {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {item.Name}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {moment(item.TimeCreated).format(
                                        "DD-MMM-YYYY HH:mm a"
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    &nbsp;
                                  </TableCell>
                                </TableRow>
                              );
                            } else {
                              return null;
                            }
                          }
                        )}
                        {selectedCOI?.map((fileName, index) => {
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                -
                                {/* {objChangeMasterFile?.Documents?.Others
                                ? objChangeMasterFile?.Documents?.Others
                                    ?.length +
                                  index +
                                  1
                                : index + 1} */}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                {fileName.Filename}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <span
                                  className="link-download"
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  {moment(new Date()).format(
                                    "DD-MMM-YYYY HH:mm a"
                                  )}
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                <ClearIcon
                                  sx={{ color: red[500], cursor: "pointer" }}
                                  onClick={() => removeFileFromUploadCOI(index)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* box-upload */}
                  <Box sx={{ display: "flex", flexDirecttion: "row", mt: 2 }}>
                    <Box className="upload-box" sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 1 }}>
                        {/* Input element for file selection */}
                        <input
                          type="file"
                          id="FileCOI2"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                        />

                        {/* Input element for file selection */}
                        <input
                          type="file"
                          onChange={handleChangeFileCOI}
                          id="FileCOI1"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                          // disabled={!isEdited}
                          multiple={false}
                        />
                        <label htmlFor="FileCOI1">
                          <Button
                            variant="outlined"
                            component="span"
                            disabled={!isEdited}
                            style={{ color: "#2C88D9" }}
                          >
                            Upload File
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 2 }}>
                        <label
                          id="FileCOI"
                          style={{
                            color: "red",
                            fontSize: 14,
                            verticalAlign: "sub",
                          }}
                        ></label>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Typography>

              {/* MOA */}
              <Typography variant="subtitle1" gutterBottom>
                <Box sx={{ textIndent: 20 }}>
                  {/* table result */}
                  <TableContainer component={Paper} sx={{ m: 2 }}>
                    <div
                      style={{ backgroundColor: "#E1E5ED", fontWeight: "bold" }}
                    >
                      Memorandum of Association (MOA)
                    </div>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="120px">
                            No.
                          </TableCell>
                          <TableCell align="left">File Name</TableCell>
                          <TableCell align="left">Upload Date/Time</TableCell>
                          <TableCell align="center" width="150px">
                            Delete
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filesSharePoint?.Account_Common_CTR_MOA?.map(
                          (item, index) => {
                            if (item) {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {item.Name}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {moment(item.TimeCreated).format(
                                        "DD-MMM-YYYY HH:mm a"
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    &nbsp;
                                  </TableCell>
                                </TableRow>
                              );
                            } else {
                              return null;
                            }
                          }
                        )}
                        {selectedMOA?.map((fileName, index) => {
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                -
                                {/* {objChangeMasterFile?.Documents?.Others
                                ? objChangeMasterFile?.Documents?.Others
                                    ?.length +
                                  index +
                                  1
                                : index + 1} */}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                {fileName.Filename}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <span
                                  className="link-download"
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  {moment(new Date()).format(
                                    "DD-MMM-YYYY HH:mm a"
                                  )}
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                <ClearIcon
                                  sx={{ color: red[500], cursor: "pointer" }}
                                  onClick={() => removeFileFromUploadMOA(index)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* box-upload */}
                  <Box sx={{ display: "flex", flexDirecttion: "row", mt: 2 }}>
                    <Box className="upload-box" sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 1 }}>
                        {/* Input element for file selection */}
                        <input
                          type="file"
                          id="FileMOA2"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                        />

                        {/* Input element for file selection */}
                        <input
                          type="file"
                          onChange={handleChangeFileMOA}
                          id="FileMOA1"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                          // disabled={!isEdited}
                          multiple={false}
                        />
                        <label htmlFor="FileMOA1">
                          <Button
                            variant="outlined"
                            component="span"
                            disabled={!isEdited}
                            style={{ color: "#2C88D9" }}
                          >
                            Upload File
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 2 }}>
                        <label
                          id="FileMOA"
                          style={{
                            color: "red",
                            fontSize: 14,
                            verticalAlign: "sub",
                          }}
                        ></label>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Typography>

              {/* Certificate of VAT Registration (ภ.พ.20) */}
              <Typography variant="subtitle1" gutterBottom>
                <Box sx={{ textIndent: 20 }}>
                  {/* table result */}
                  <TableContainer component={Paper} sx={{ m: 2 }}>
                    <div
                      style={{ backgroundColor: "#E1E5ED", fontWeight: "bold" }}
                    >
                      Certificate of VAT Registration (ภ.พ.20)
                    </div>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="120px">
                            No.
                          </TableCell>
                          <TableCell align="left">File Name</TableCell>
                          <TableCell align="left">Upload Date/Time</TableCell>
                          <TableCell align="center" width="150px">
                            Delete
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filesSharePoint?.Account_Common_CTR_VAT_Reg?.map(
                          (item, index) => {
                            if (item) {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {item.Name}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {moment(item.TimeCreated).format(
                                        "DD-MMM-YYYY HH:mm a"
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    &nbsp;
                                  </TableCell>
                                </TableRow>
                              );
                            } else {
                              return null;
                            }
                          }
                        )}
                        {selectedRegVat?.map((fileName, index) => {
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                -
                                {/* {objChangeMasterFile?.Documents?.Others
                                ? objChangeMasterFile?.Documents?.Others
                                    ?.length +
                                  index +
                                  1
                                : index + 1} */}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                {fileName.Filename}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <span
                                  className="link-download"
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  {moment(new Date()).format(
                                    "DD-MMM-YYYY HH:mm a"
                                  )}
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                <ClearIcon
                                  sx={{ color: red[500], cursor: "pointer" }}
                                  onClick={() =>
                                    removeFileFromUploadRegVat(index)
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* box-upload */}
                  <Box sx={{ display: "flex", flexDirecttion: "row", mt: 2 }}>
                    <Box className="upload-box" sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 1 }}>
                        {/* Input element for file selection */}
                        <input
                          type="file"
                          id="FileRegVat2"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                        />

                        {/* Input element for file selection */}
                        <input
                          type="file"
                          onChange={handleChangeFileRegVat}
                          id="FileRegVat1"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                          // disabled={!isEdited}
                          multiple={false}
                        />
                        <label htmlFor="FileRegVat1">
                          <Button
                            variant="outlined"
                            component="span"
                            disabled={!isEdited}
                            style={{ color: "#2C88D9" }}
                          >
                            Upload File
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 2 }}>
                        <label
                          id="FileRegVat"
                          style={{
                            color: "red",
                            fontSize: 14,
                            verticalAlign: "sub",
                          }}
                        ></label>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Typography>

              {/* List of the Shareholders (บอจ.5) */}
              <Typography variant="subtitle1" gutterBottom>
                <Box sx={{ textIndent: 20 }}>
                  {/* table result */}
                  <TableContainer component={Paper} sx={{ m: 2 }}>
                    <div
                      style={{ backgroundColor: "#E1E5ED", fontWeight: "bold" }}
                    >
                      List of the Shareholders (บอจ.5)
                    </div>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="120px">
                            No.
                          </TableCell>
                          <TableCell align="left">File Name</TableCell>
                          <TableCell align="left">Upload Date/Time</TableCell>
                          <TableCell align="center" width="150px">
                            Delete
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filesSharePoint?.Account_Common_CTR_List_Sharehold?.map(
                          (item, index) => {
                            if (item) {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {item.Name}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {moment(item.TimeCreated).format(
                                        "DD-MMM-YYYY HH:mm a"
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    &nbsp;
                                  </TableCell>
                                </TableRow>
                              );
                            } else {
                              return null;
                            }
                          }
                        )}
                        {selectedListShareHold?.map((fileName, index) => {
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                -
                                {/* {objChangeMasterFile?.Documents?.Others
                                ? objChangeMasterFile?.Documents?.Others
                                    ?.length +
                                  index +
                                  1
                                : index + 1} */}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                {fileName.Filename}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <span
                                  className="link-download"
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  {moment(new Date()).format(
                                    "DD-MMM-YYYY HH:mm a"
                                  )}
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                <ClearIcon
                                  sx={{ color: red[500], cursor: "pointer" }}
                                  onClick={() =>
                                    removeFileFromUploadListShareHold(index)
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* box-upload */}
                  <Box sx={{ display: "flex", flexDirecttion: "row", mt: 2 }}>
                    <Box className="upload-box" sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 1 }}>
                        {/* Input element for file selection */}
                        <input
                          type="file"
                          id="FileListShareHold2"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                        />

                        {/* Input element for file selection */}
                        <input
                          type="file"
                          onChange={handleChangeFileListShareHold}
                          id="FileListShareHold1"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                          // disabled={!isEdited}
                          multiple={false}
                        />
                        <label htmlFor="FileListShareHold1">
                          <Button
                            variant="outlined"
                            component="span"
                            disabled={!isEdited}
                            style={{ color: "#2C88D9" }}
                          >
                            Upload File
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 2 }}>
                        <label
                          id="FileListShareHold"
                          style={{
                            color: "red",
                            fontSize: 14,
                            verticalAlign: "sub",
                          }}
                        ></label>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Typography>

              {/* Registration Issued by Ministry of Energy (For petroleum) */}
              <Typography variant="subtitle1" gutterBottom>
                <Box sx={{ textIndent: 20 }}>
                  {/* table result */}
                  <TableContainer component={Paper} sx={{ m: 2 }}>
                    <div
                      style={{ backgroundColor: "#E1E5ED", fontWeight: "bold" }}
                    >
                      Registration Issued by Ministry of Energy (For petroleum)
                    </div>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="120px">
                            No.
                          </TableCell>
                          <TableCell align="left">File Name</TableCell>
                          <TableCell align="left">Upload Date/Time</TableCell>
                          <TableCell align="center" width="150px">
                            Delete
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filesSharePoint?.Account_Common_CTR_Reg_by_MoE?.map(
                          (item, index) => {
                            if (item) {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {item.Name}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {moment(item.TimeCreated).format(
                                        "DD-MMM-YYYY HH:mm a"
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    &nbsp;
                                  </TableCell>
                                </TableRow>
                              );
                            } else {
                              return null;
                            }
                          }
                        )}
                        {selectedMOE?.map((fileName, index) => {
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                -
                                {/* {objChangeMasterFile?.Documents?.Others
                                ? objChangeMasterFile?.Documents?.Others
                                    ?.length +
                                  index +
                                  1
                                : index + 1} */}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                {fileName.Filename}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <span
                                  className="link-download"
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  {moment(new Date()).format(
                                    "DD-MMM-YYYY HH:mm a"
                                  )}
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                <ClearIcon
                                  sx={{ color: red[500], cursor: "pointer" }}
                                  onClick={() => removeFileFromUploadMOE(index)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* box-upload */}
                  <Box sx={{ display: "flex", flexDirecttion: "row", mt: 2 }}>
                    <Box className="upload-box" sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 1 }}>
                        {/* Input element for file selection */}
                        <input
                          type="file"
                          id="FileListMOE2"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                        />

                        {/* Input element for file selection */}
                        <input
                          type="file"
                          onChange={handleChangeFileMOE}
                          id="FileListMOE1"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                          // disabled={!isEdited}
                          multiple={false}
                        />
                        <label htmlFor="FileListMOE1">
                          <Button
                            variant="outlined"
                            component="span"
                            disabled={!isEdited}
                            style={{ color: "#2C88D9" }}
                          >
                            Upload File
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 2 }}>
                        <label
                          id="FileListMOE"
                          style={{
                            color: "red",
                            fontSize: 14,
                            verticalAlign: "sub",
                          }}
                        ></label>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Typography>

              {/* Other Documents */}
              <Typography variant="subtitle1" gutterBottom>
                <Box sx={{ textIndent: 20 }}>
                  {/* table result */}
                  <TableContainer component={Paper} sx={{ m: 2 }}>
                    <div
                      style={{ backgroundColor: "#E1E5ED", fontWeight: "bold" }}
                    >
                      Other Documents
                    </div>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="120px">
                            No.
                          </TableCell>
                          <TableCell align="left">File Name</TableCell>
                          <TableCell align="left">Upload Date/Time</TableCell>
                          <TableCell align="center" width="150px">
                            Delete
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filesSharePoint?.Account_Common_CTR_Others?.map(
                          (item, index) => {
                            if (item) {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {item.Name}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    component="th"
                                    scope="row"
                                  >
                                    <span
                                      className="link-download"
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {moment(item.TimeCreated).format(
                                        "DD-MMM-YYYY HH:mm a"
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                  >
                                    &nbsp;
                                  </TableCell>
                                </TableRow>
                              );
                            } else {
                              return null;
                            }
                          }
                        )}
                        {selectedOther?.map((fileName, index) => {
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                -
                                {/* {objChangeMasterFile?.Documents?.Others
                                ? objChangeMasterFile?.Documents?.Others
                                    ?.length +
                                  index +
                                  1
                                : index + 1} */}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                {fileName.Filename}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <span
                                  className="link-download"
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  {moment(new Date()).format(
                                    "DD-MMM-YYYY HH:mm a"
                                  )}
                                </span>
                              </TableCell>
                              <TableCell align="center">
                                <ClearIcon
                                  sx={{ color: red[500], cursor: "pointer" }}
                                  onClick={() =>
                                    removeFileFromUploadList(index)
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* box-upload */}
                  <Box sx={{ display: "flex", flexDirecttion: "row", mt: 2 }}>
                    <Box className="upload-box" sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 1 }}>
                        {/* Input element for file selection */}
                        <input
                          type="file"
                          id="FileOther2"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          // multiple // Allow multiple file selection
                          style={{ display: "none" }}
                        />

                        {/* Input element for file selection */}
                        <input
                          type="file"
                          onChange={handleChangeFileOther}
                          id="FileOther1"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          style={{ display: "none" }}
                          // disabled={!isEdited}
                          multiple={false}
                        />
                        <label htmlFor="FileOther1">
                          <Button
                            variant="outlined"
                            component="span"
                            disabled={!isEdited}
                            style={{ color: "#2C88D9" }}
                          >
                            Upload File
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 2 }}>
                        <label
                          id="FileOther"
                          style={{
                            color: "red",
                            fontSize: 14,
                            verticalAlign: "sub",
                          }}
                        ></label>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Typography>
            </Box>
          )}
        </Box>
      </CardContent>

      {/* visible submit update btn */}
      <>
        <Button
          id="check-form-data-register"
          style={{
            visibility: "hidden",
          }}
          onClick={() => {
            if (objChangeMasterFile) {
              if (selectedOther.length > 0) {
                objChangeMasterFile.Documents?.Others.push(...selectedOther);
              }
              if (selectedAudited.length > 0) {
                objChangeMasterFile.Documents?.Others.push(...selectedAudited);
              }
              // formData(objChangeMasterFile);
            }
          }}
        >
          submit
        </Button>
        <Button
          id="check-form-data-register-save-draft"
          style={{
            visibility: "hidden",
          }}
          onClick={() => {
            if (objChangeMasterFile) {
              if (selectedOther.length > 0) {
                objChangeMasterFile.Documents?.Others.push(...selectedOther);
              }
              if (selectedAudited.length > 0) {
                objChangeMasterFile.Documents?.Others.push(...selectedAudited);
              }
              // formDataDraft(objChangeMasterFile);
            }
          }}
        >
          update
        </Button>
      </>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={required.active}
        autoHideDuration={6000}
        onClose={() => {
          setRequired({
            fields: "",
            active: false,
          });
        }}
      >
        <Alert
          onClose={() => {
            setRequired({
              fields: "",
              active: false,
            });
          }}
          variant="filled"
          severity="warning"
        >
          Required Fields <b> {required.fields}</b>
        </Alert>
      </Snackbar>
    </Card>
  );
}
